import { render, staticRenderFns } from "./BookMeta.vue?vue&type=template&id=910fcbda&"
import script from "./BookMeta.vue?vue&type=script&lang=js&"
export * from "./BookMeta.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./BookMeta.vue?vue&type=style&index=0&lang=less&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports